export const sourceAuthorizationList = [
  "eightwings/getdirectdeliverylist",
  "eightwings/getlistwithfeedrequest",
  "aarstorages/getpnlist",
  "vwuserss",
  "PbhRequestOrderUpdateHistorys",
  "EntityHistorys",
  "vworderheaders",
  "requestreserves",
  "pnpoolmasters",
  "quarantinereasons",
  "quarantinereasons/reasons",
  "quarantinedetails",
  "requestorders/quarantine",
  "pbhrequestorders/dashboardpbh",
  "pbhrequestorders/dashboardcms",
  "whs",
  "whs/getSubPns",
  "reserveds",
  "reserveds/getSubPns",
  "alternatepns",
  "pbhrequestalternatepns",
  "alternatepns/getSubPns",
  "workorders",
  "workorders/getSubPns",
  "repairorders",
  "repairorders/getSubPns",
  "poexs",
  "rns",
  "getrnwithalternate",
  "poexs/getSubPns",
  "abilitycontrols",
  "pbhrequeststatusinfo/reference",
  "requeststatusinfo/reference",
  "requeststatusinfos",
  "pbhrequeststatusinfos",
  "shopreports",
  "PbhRequestOrderHistorys",
  "ParameterDefinitions",
  "requestserviceables",
  "unserviceableremovereasontypes",
  "unserviceableremovereasondetails",
  "cdmaircraft",
  "cdmcontacts",
  "cdmheaders",
  "cdmadressinfos",
  "cdmlocations",
  "requestorderexcusablehistorys",
  "requestorders/dashboardrbh",
  "pbhrequestorders/cockpit/svcunsvcpndifference",
  "pbhrequestorders/cockpit/requestedpnunsvcpndifference",
  "pbhrequestorders/cockpit/requestaircraft",
  "pbhrequestorders/cockpit/serviceablereturn",
  "pbhrequestorders/cockpit/capability",
  "pbhrequestorders/cockpit/outofstock",
  "pbhrequestorders/cockpit/outofstockview",
  "pbhrequestorders/cockpit/responsetime",
  "pbhrequestresponsetimeexceptions",
  "pbhrequestorders/cockpit/rejectionrate",
  "cdmservicelevel",
  "vwshopreportfields",
  "requestorders/search",
  "pbhrequestorders/search",
  "pbhrequestorders/getrefnowithunsvc",
  "pbhrequestorders/getpbhrequestlist",
  "requestorders/getrefnowithunsvc",
  "reliabilityreports/isexclusionpnbyrequest",
  "reliabilityreports/manualcreate",
  "reliabilityreports/isexclusionpnbythyrequest",
  "reliabilityreports/thymanualcreate",
  "requestorders/shop",
  "ServiceableShipmentTypes",
  "requestremarks",
  "pbhrequestremarks",
  "pbhrequestreserves",
  "pbhrequestunserviceables",
  "cdmnewrequest",
  "vwpnmasters",
  "pbhrequestorderfilerelations",
  "cdmpoolpns",
  "cdmsystemtransactionmels",
  "cdmaircraft/FetchAcTypes",
  "cdmaircraft/FetchFleetTypes",
  "redis/getallkeys",
  "homebasecomponents/getmaindata",
  "pbhwaitingresponses",
  "mastercustomers",
  "mastertypes",
  "pbhrequestorders/cockpit/activeaircraft",
  "pbhrequestorders/cockpit/activeaircraftdetail",
  "masterfiles",
  "masterfiles/existingfiles",
];
export default sourceAuthorizationList;
